// extracted by mini-css-extract-plugin
export var addButton = "_ax-0";
export var border = "_ax-8";
export var check = "_ax-h";
export var danger = "_ax-6";
export var dropdownContainer = "_ax-1";
export var editModalBody = "_ax-j";
export var footerContainer = "_ax-i";
export var fullWidth = "_ax-a";
export var hide = "_ax-9";
export var icon = "_ax-3";
export var input = "_ax-7";
export var inputFlex = "_ax-b";
export var inputWrapper = "_ax-c";
export var manualFocus = "_ax-5";
export var optionButton = "_ax-4";
export var pillWrapper = "_ax-e";
export var pointer = "_ax-2";
export var showOverflow = "_ax-f";
export var tagsFlex = "_ax-d";
export var xButton = "_ax-g";